import { connect } from 'react-redux';
import RadioButtonFieldComponent
  from './../Components/RadioButtonFieldComponent';

export const mapStateToProps = (state, ownProps) => {
  return {
    isDisabled: ownProps.isDisabled,
    submitLabel: ownProps.submitLabel,
    options: ownProps.options,
    defaultOption: ownProps.defaultOption
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return { onSubmit: ownProps.onSubmit };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RadioButtonFieldComponent);


// WEBPACK FOOTER //
// src/Containers/RadioButtonFieldContainer.jsx